export default "__VITE_ASSET__C8kbRbGx__"